import { Modal } from "react-bootstrap";
import i18n from '@whatsmenu/i18n'

interface CancelNoSlugModalProps {
  show: boolean;
  setShow: (data: boolean) => void;
  onConfirmWithMessage: () => void;
  onConfirmWithoutMessage: () => void;
}

export function CancelPdvModal({
  show,
  setShow,
  onConfirmWithMessage,
  onConfirmWithoutMessage
}: CancelNoSlugModalProps) {
  return (
    <Modal
      show={show}
      onHide={() => setShow(false)}
      style={{ 
        zIndex: 99999,
        marginTop: '25vh' 
      }}
    >
      <Modal.Header closeButton>
        <Modal.Title>{i18n.t('cancel_order')}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {i18n.t('confirm_send_to_whatsapp')}
      </Modal.Body>
      <Modal.Footer>
        <button
          className="btn btn-secondary"
          onClick={() => {
            setShow(false);
            onConfirmWithoutMessage();
          }}
        >
          {i18n.t('dont_send_message')}
        </button>
        <button
          className="btn btn-primary"
          onClick={() => {
            setShow(false);
            onConfirmWithMessage();
          }}
        >
          {i18n.t('send_message')}
        </button>
      </Modal.Footer>
    </Modal>
  );
}
